var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9C10.6716 9 10 9.67157 10 10.5V21.5C10 22.3284 10.6716 23 11.5 23H16C16.2761 23 16.5 22.7761 16.5 22.5C16.5 22.2239 16.2761 22 16 22H11.5C11.2239 22 11 21.7761 11 21.5V10.5C11 10.2239 11.2239 10 11.5 10H16C16.2761 10 16.5 9.77614 16.5 9.5C16.5 9.22386 16.2761 9 16 9H11.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8456 19.8548C16.6397 20.0484 16.306 20.0484 16.1001 19.8548L12 16L16.1001 12.1452C16.306 11.9516 16.6397 11.9516 16.8456 12.1452C17.0515 12.3387 17.0515 12.6525 16.8456 12.846L14.0228 15.5H21C21.2761 15.5 21.5 15.7239 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5H14L16.8456 19.154C17.0515 19.3475 17.0515 19.6613 16.8456 19.8548Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.d956a35bcb7fd72f559e548688830026.svg";
export { ForwardRef as ReactComponent };